export const one = require('./01.png');
export const two = require('./02.png');
export const three = require('./03.png');
